module.exports = __webpack_public_path__ + "static/delivery/img/dw_actual.032b1a9b.png";